export default Object.freeze({
  activeIRsGroupedByType: [],
});
